const BackToTopSvg = (props) => (
  <svg
    width="15"
    height="18"
    viewBox="0 0 15 18"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    aria-hidden="true"
    {...props}
  >
    <path
      d="M8.38672 3C8.38672 2.44772 7.939 2 7.38672 2C6.83443 2 6.38672 2.44772 6.38672 3V17C6.38672 17.5523 6.83443 18 7.38672 18C7.939 18 8.38672 17.5523 8.38672 17V3Z"
      fill="#1A1A1A"
    />
    <path
      d="M12.758 7.379L7.378 2L2 7.379"
      stroke="#1A1A1A"
      strokeWidth="2"
      strokeLinecap="round"
    />
  </svg>
);

export default BackToTopSvg;
